import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'statistiche',
    initialState: {
        tipologia: [],
        generali: [],
        anno: [],
        statusAction: 'READY',
    },
    actions: ['GET_STATISTICHE'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_STATISTICHE_SUCCESS:
                return {
                    ...state,
                    tipologia: action.payload.tipologia,
                    generali: action.payload.generali,
                    anno: action.payload.anno,
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getStatisticheRequest: (codiceUtente) => ({
            type: types.GET_STATISTICHE_REQUEST,
            payload: { codiceUtente },
        }),
        getStatisticheSuccess: ({ tipologia, generali, anno }) => ({
            type: types.GET_STATISTICHE_SUCCESS,
            payload: { tipologia, generali, anno },
        }),
        getStatisticheFailed: error => ({ type: types.GET_STATISTICHE_FAILED, error: true, payload: { error } }),
    }),
});
